import Heading from '../Typography/Heading'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'

interface Props {
  points: number
  size: 'S' | 'L'
}

function PriceRowPointsSpend(props: Props) {
  const { points, size } = props

  return (
    <Heading variant={size === 'S' ? 'heading6' : 'heading4'}>
      <FormatLoyaltyPoints points={points} abbreviated />
    </Heading>
  )
}

export default PriceRowPointsSpend
